import {
  ActionType,
  IUpdateUserDepartmentPayload,
  UpdateUserDepartmentResponse,
} from "models/userListBusiness/updateUserDepartment";

export const updateUserDepartmentAction = (
  payload: IUpdateUserDepartmentPayload
) => {
  return {
    type: ActionType.UPDATE_USER_DEPARTMENT,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.UPDATE_USER_DEPARTMENT_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: UpdateUserDepartmentResponse) => {
  return {
    type: ActionType.UPDATE_USER_DEPARTMENT_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.UPDATE_USER_DEPARTMENT_RESET,
  };
};
